import React, { useState, useEffect, useMemo } from "react";
import StaticHtmlContent from './staticHtmlContent';

/**
 * icons classes are in git\sites\MyBSWHealth2019\wwwroot\scss\exclude\global\_icons.scss
*/
/** 
 * @param {any} props Component props
 * @param {string} props.icon name of icon className
 * @param {string|JSX.Element} props.message displayed message ignored if there are props.children (children element inside the MessageWithIcon tag)
 * */
const MessageWithIcon = (props) => {

    return  <div className="details-icon-prepend">
                <div className="icon-col">
                    <span className={props.icon} />
                </div>
                <div className="details-col">
            {props.children ? props.children :
                <StaticHtmlContent content={props.message} />}
                </div>
            </div>;
}

export default MessageWithIcon;